import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-tabs" }
const _hoisted_3 = { class: "modal-body scrollbar" }
const _hoisted_4 = {
  key: 2,
  class: "empty-tab"
}

import { ref, toRefs, watch, onMounted } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import { ElevationResponse, Elevation } from '@/types/elevations';
import ExteriorOptions from '../ExteriorOptions.vue';
import DesignOptions from '../DesignOptions.vue';
import { apiFetchElevationDetails } from '@/api/elevation-api';
import { Lot } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ElevationModal',
  props: {
    showModal: { type: Boolean },
    selectedPlan: {},
    areaId: {},
    selectedLotInfo: {},
    hasAvailableLots: { type: Boolean }
  },
  emits: ['update:showModal', 'closeModal'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { showModal, selectedPlan, areaId, selectedLotInfo, hasAvailableLots } = toRefs(props);

const emit = __emit;

const localShowModal = ref(props.showModal);

watch(
  () => props.showModal,
  (val) => (localShowModal.value = val)
);
watch(localShowModal, (val) => emit('update:showModal', val));

const tab = ref<'exterior' | 'design'>('exterior');
const selected = ref<number | null>(0);

const elevations = ref<Elevation[]>([]);
const planName = ref('');
const loadingElevations = ref(false);
const elevationsError = ref<string | null>(null);

const designOptions = ref([
  {
    title: 'Brick',
    description: 'Auberdean',
    img: 'https://assetcloud.dreeshomes.com/transform/e1aa94cd-3aaa-4754-bd89-1ebb1a4fbbfb/Aiden_Kitchen-jpg?scale=small&io=transform%3Afill%2Cwidth%3A501',
  },
  {
    title: 'Mortar Color',
    description: 'Buff',
    img: 'https://assetcloud.dreeshomes.com/transform/e1aa94cd-3aaa-4754-bd89-1ebb1a4fbbfb/Aiden_Kitchen-jpg?scale=small&io=transform%3Afill%2Cwidth%3A501',
  },
  {
    title: 'Mortar Finish',
    description: 'Tooled and Tiled',
    img: 'https://assetcloud.dreeshomes.com/transform/e1aa94cd-3aaa-4754-bd89-1ebb1a4fbbfb/Aiden_Kitchen-jpg?scale=small&io=transform%3Afill%2Cwidth%3A501',
  },
]);

const handleDesignTabClick = () => {
  if (selectedLotInfo.value) {
    tab.value = 'design';
  }
};

const fetchElevations = async () => {
  loadingElevations.value = true;
  elevationsError.value = null;
  try {
    const response = await apiFetchElevationDetails(
      areaId.value,
      selectedPlan.value.neighborhood_code,
      selectedPlan.value.plan_id
    );
    elevations.value = response?.elevations || [];
    planName.value = response.plan_name;
  } catch (err) {
    elevationsError.value = 'Failed to load elevations.';
  } finally {
    loadingElevations.value = false;
  }
};

watch(
  selectedPlan,
  () => {
    if (
      selectedPlan.value.plan_id &&
      selectedPlan.value.neighborhood_code &&
      areaId.value
    ) {
      fetchElevations();
    }
  },
  { immediate: true, deep: true }
);
watch(showModal, (newVal) => {
  if (newVal) {
    tab.value = 'exterior';
  }
});
const close = () => {
  emit('closeModal');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    modelValue: localShowModal.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localShowModal).value = $event)),
    classes: "flex justify-end",
    "content-class": "modal-content",
    "click-to-close": true,
    onClosed: _cache[4] || (_cache[4] = ($event: any) => (emit('closeModal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref(selectedPlan).plan_name) + " Plan", 1),
        _createElementVNode("i", {
          onClick: close,
          "aria-label": "close icon",
          class: "emb_closeicon close-btn"
        })
      ]),
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(['tab-btn', { active: tab.value === 'exterior' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'exterior'))
        }, " Exterior Options ", 2),
        false
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass([
          'tab-btn',
          { active: tab.value === 'design', disabled: !_unref(selectedLotInfo)?.id },
        ]),
              onClick: handleDesignTabClick
            }, " Design Options ", 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_3, [
        (tab.value === 'exterior')
          ? (_openBlock(), _createBlock(ExteriorOptions, {
              key: 0,
              elevations: elevations.value,
              selectedPlan: _unref(selectedPlan),
              selected: selected.value,
              loading: loadingElevations.value,
              error: elevationsError.value,
              planName: planName.value,
              hasAvailableLots: _unref(hasAvailableLots),
              planPriceLowWithPremium: _unref(selectedPlan)?.price_low_with_premium,
              "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => (selected.value = $event))
            }, null, 8, ["elevations", "selectedPlan", "selected", "loading", "error", "planName", "hasAvailableLots", "planPriceLowWithPremium"]))
          : (tab.value === 'design')
            ? (_openBlock(), _createBlock(DesignOptions, {
                key: 1,
                designOptions: designOptions.value,
                selected: selected.value,
                "onUpdate:selected": _cache[2] || (_cache[2] = ($event: any) => (selected.value = $event))
              }, null, 8, ["designOptions", "selected"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("p", null, "No items available.", -1)
              ]))]))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})